import React, { FunctionComponent } from 'react';
import MaintenanceImage from '../assets/images/maintenance.png';
import translate from '../language/translate';

export const Maintenance: FunctionComponent = () => {
  return (
    <div className="bg-blue w-screen h-screen">
      <div className="container pt-header-bar-small flex flex-col items-center px-lg md:px-0 md:pt-header-bar md:mx-auto md:w-public-container">
        <h1 className="text-white text-xxxxl mb-xxl">
          {translate('Global.MAYDAY')}
        </h1>
        <img src={MaintenanceImage} className="mb-xxl" />
        <p className="text-white text-center mb-lg">
          {translate('Maintenance.BODY')}
        </p>
        <p className="text-white text-center mb-lg">
          {translate('Maintenance.CHECK_LATER')}
        </p>
        <p className="text-white text-center mb-lg">
          {translate('Maintenance.THANKS')}
        </p>
      </div>
    </div>
  );
};
